export default __webpack_public_path__ + "static/media/25.814c64a3.jpg";